<template>
  <div v-loading="loading" class="exam_list">
    <img src="@/assets/img/exam_online_bg.png" class="bg-img">
    <div class="exam_list_content">
      <div class="top_area">
        <div class="form_box" v-if="userInfo.hospital_id">
          <el-form ref="formLabelAlign" label-position="top" label-width="80px" :model="formLabelAlign" :inline="true">
            <el-form-item label="名称" prop="ksd_title">
              <el-input v-model="formLabelAlign.ksd_title" size="small" placeholder="请输入关键字" clearable
                @keyup.enter.native="searchList" />
            </el-form-item>
            <el-form-item label="考试状态" prop="ksd_status">
              <el-select v-model="formLabelAlign.ksd_status" placeholder="请选择考试状态" size="small" clearable>
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="项目" prop="ksd_app_id">
              <el-select v-model="formLabelAlign.ksd_app_id" filterable clearable placeholder="请选择项目" size="small">
                <el-option v-for="item in proOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-form>
          <div class="form_btn">
            <el-button type="primary" size="small" @click="searchList">搜索</el-button>
            <el-button size="small" @click="clear">清空</el-button>
          </div>
        </div>
        <el-button type="primary" size="small" class="add_btn" @click="addExam">添加考试</el-button>
      </div>

      <div class="scroll_area">
        <div v-if="userExamList.length !== 0" class="exam-grid">
          <div v-for="(item, index) in userExamList" :key="index" class="list-item">
            <div class="list-item-header">
              <el-tag v-if="item.status === 0" class="notStarted" size="mini">未开始</el-tag>
              <el-tag v-else-if="item.status === 1" class="inHand" size="mini">进行中</el-tag>
              <el-tag v-else class="end" size="mini">已结束</el-tag>
              <span class="list-item-title" :title="item.title">{{ item.title }}</span>
            </div>
            <div class="list-item-info">
              <img src="@/assets/img/km.png">{{ item.app_name }}
            </div>
            <div class="list-item-date">
              <span><img src="@/assets/img/date.png">起：{{ item | startTimeFilter }}</span>
              <span class="list-item-date-end"><img src="@/assets/img/date.png">止：{{ item | endTimeFilter }}</span>
            </div>
            <div class="list-item-action">
              <div v-if="item.status === 0" class="count-down">倒计时：
                <count-down :end-time="getExamTime(item.start_time)" @countEnd="countEnd" />
              </div>
              <el-tag
                v-if="item.status === 1 && (item.time === 0 || !(item.review === 1 && item.time === 1) || item.answer_number === 1)"
                class="goExamOutline" @click="goExamOutline(item.id)">进入考试</el-tag>
              <el-tag
                v-else-if="item.status === 2 || (item.review === 1 && (item.answer_number - item.time === 0 || item.answer_number === 0))"
                class="scoreQuery" @click="goExamOutline(item.id,true)">回顾考试</el-tag>
            </div>
          </div>
        </div>
        <el-empty v-else description="您还没有任何考试哦" class="elEmpty" />
      </div>

      <div class="bottom_area">
        <Pagination
          v-show="queryParams.total > 0"
          :total="queryParams.total"
          :page.sync="queryParams.page"
          :size.sync="queryParams.size"
          @pagination="getExamList"
        />
      </div>
    </div>
    <!-- 添加考试码 -->
    <addExamCode :add-visible="addVisible" @update:addVisible="addVisibleChange" @setCode="setCode" />
    <!-- 完善身份 -->
    <improveIdentity :identity-show="identityShow" @update:identity="identityShowChange" @finish="identityFinish"
      :switch-hospital-id="switchHospitalId"></improveIdentity>
    <!-- 考试提示 -->
    <examTips :tip-parma="tipParmas" />
  </div>
</template>
<script>
import { getUserExamPaginateApi, getApps, getExamDetailed, getQuestion, getExamInfoApi, getInfo } from '@/http/index'
import countDown from '@/components/countdown'
import Pagination from '@/components/Pagination'
import addExamCode from './child/add.vue'
import examTips from './child/tips.vue'
import { processDate } from '../../utils/index'
import { mapState } from 'vuex';

export default {
  components: {
    countDown,
    Pagination,
    addExamCode,
    examTips,
    improveIdentity: () => import('./child/improveIdentity.vue')
  },
  filters: {
    startTimeFilter(val) {
      return processDate(val.start_time, val.ent_time)
    },
    endTimeFilter(val) {
      return processDate(val.ent_time, val.start_time, 1)
    }
  },
  computed: {
    ...mapState(['userInfo',])
  },
  data() {
    return {
      examId: null,
      switchHospitalId: null,
      identityShow: false,
      examCode: null,
      userExamList: [],
      endText: '考试已结束',
      formLabelAlign: {
        ksd_title: '',
        ksd_status: '',
        ksd_app_id: ''
      },
      queryParams: {
        page: 1,
        size: 10,
        total: 0
      },
      statusOptions: [{
        label: '未开始',
        value: 0
      }, {
        label: '进行中',
        value: 1
      }, {
        label: '已结束',
        value: 2
      }],
      proOptions: [],
      addVisible: false,
      statisticsVisible: false,
      tipParmas: {
        tipsVisible: false,
        tipsContent: ''
      },
      loading: true,
      isSafari: false,
      countEndTimer: null,
    }
  },
  beforeDestroy() {
    if (this.countEndTimer) {
      clearTimeout(this.countEndTimer)
      this.countEndTimer = null
    }
  },
  async created() {
    if (localStorage.getItem('search')) {
      const parmas = JSON.parse(localStorage.getItem('search'))
      this.formLabelAlign.ksd_title = parmas.ksd_title
      this.formLabelAlign.ksd_status = parmas.ksd_status
      this.formLabelAlign.ksd_app_id = parmas.ksd_app_id
    }
    this.checkBrowser();
    if (localStorage.getItem('hospital_id')) {
      this.getProject();
      this.getExamList();
    } else {
      this.loading = false
    }
    window.onkeyup = window.onkeydown = window.onKeyPress = document.onkeyup = document.onkeydown = document.onKeyPress = document.body.onkeyup = document.body.onkeydown = document.body.onKeyPress  = function() {
      return true
    };
  },
  methods: {
    identityShowChange() {
      this.identityShow = false
    },
    getExamTime(time) {
      if (this.isSafari && time) {
        return new Date(this.formatDateForSafari(time)).getTime() / 1000 + ''
      } else {
        return new Date(time).getTime() / 1000 + ''
      }
    },
    // 针对 Safari 浏览器格式化日期
    formatDateForSafari(dateString) {
      // 对于 Safari，使用合适的日期格式化方法
      return dateString.replace(/-/g, '/');
    },
    // 检查是否为 Safari 浏览器
    checkBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      this.isSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
      localStorage.setItem('isSafari', this.isSafari)
    },
    // 获取项目
    async getProject() {
      const res = await getApps({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id')
      })
      if (res.code === 200) {
        this.proOptions = res.data;
      }
    },
    async getExamList() {
      this.loading = true;
      const paramsObj = {
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        ksd_title: this.formLabelAlign.ksd_title,
        ksd_status: this.formLabelAlign.ksd_status,
        ksd_app_id: this.formLabelAlign.ksd_app_id,
        page: this.queryParams.page,
        size: this.queryParams.size
      }
      getUserExamPaginateApi(paramsObj).then(res => {
        this.loading = false;
        this.userExamList = res.data.data;
        this.queryParams.total = res.data.total;
      }).catch(error => {
        this.loading = false;
      })
    },
    addExam() {
      this.addVisible = true;
    },
    async goExamOutline(id,isReview='') {
      this.$router.push({
        path: "/home/examOutline",
        query: {
          id: id,
          isReview: isReview
        }
      })
    },
    searchList() {
      this.queryParams.page = 1;
      localStorage.setItem('search', JSON.stringify(this.formLabelAlign))
      this.getExamList();
    },
    clear() {
      this.formLabelAlign = {
        ksd_title: '',
        ksd_status: '',
        ksd_app_id: ''
      }
      this.queryParams.page = 1;
      localStorage.removeItem('search')
      this.getExamList();
    },
    addVisibleChange() {
      this.addVisible = false;
    },
    async setCode(code) {
      this.addVisible = false;
      this.loading = true
      this.examCode = code
      const queryData = {
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        register_hospital_id: localStorage.getItem('hospital_id') || '',
        code: code,
        is_confirm: 0,
      }
      try {
        const res = await getExamInfoApi(queryData)
        if (res.code === 200) {
          const hospitalId = Number(localStorage.getItem('hospital_id'))
          this.switchHospitalId = res.data.hospital_id
          this.examId = res.data.id
          if (res.data.is_in_hospital) {
            if (hospitalId === res.data.hospital_id) {
              this.identityFinish()
            } else {
              this.loading = false
              this.$confirm(`您输入的是"${res.data.hospital}"的考试码，是否参加考试`, '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.identityFinish()
              }).catch(() => {
                this.switchHospitalId = null
              });
            }
          } else {
            this.loading = false
            this.$confirm(`您输入的是"${res.data.hospital}"的考试码，是否参加考试`, '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.identityShow = true
            }).catch(() => {
              this.switchHospitalId = null
            });
          }
        } else {
          this.loading = false
        }
      } catch (error) {
        this.loading = false
      }
    },
    async identityFinish() {
      this.loading = true
      // 整个系统切换医院
      const resUserInfo = await getInfo({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: this.switchHospitalId
      })
      if (resUserInfo.code === 200) {
        localStorage.setItem('hospital_id', this.switchHospitalId)
        this.$store.commit('editUserInfo', resUserInfo.data);
      }
      const queryData = {
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        register_hospital_id: localStorage.getItem('hospital_id') || '',
        code: this.examCode,
        is_confirm: 1,
      }
      const res = await getExamInfoApi(queryData)
      this.loading = false
      if (res.code === 200) {
        this.$router.push({
          path: "/home/examOutline",
          query: {
            id: this.examId
          }
        })
      }
    },
    countEnd() {
      if (this.countEndTimer) {
        clearTimeout(this.countEndTimer)
      }
      this.countEndTimer = setTimeout(() => {
        this.countEndTimer = null
        this.getExamList();
      }, 200);
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-form--inline .el-form-item__label {
    line-height: 1;
  }

  .el-form--inline .el-form-item {
    margin: 0 16px 0 0;
  }

  .contentCode {
    color: #303030;
  }

  .contentCode span {
    background-color: #F5BC41 !important;
    color: #fff;
  }
}

.exam_list {
  background-color: #F7F8FA;
  height: 100%;
  position: relative;
  overflow: hidden;
  padding: 16px 24px;
}

.exam_list_content {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  z-index: 1;
}

.bg-img {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  pointer-events: none;
}

.top_area {
  flex-shrink: 0;

  .form_box {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 16px;
  }

  .add_btn {
    margin-bottom: 10px;
    width: 80px;
  }
}

.scroll_area {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.bottom_area {
  flex-shrink: 0;

  ::v-deep .position-page {
    position: static;
  }
}

.elEmpty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.list-item {
  background: #fff;
  border: 1px solid #EEEEEE;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  overflow: hidden;
}

.list-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.list-item-title {
  font-size: 15px;
  font-weight: 500;
  color: #303030;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
}

.notStarted {
  background: #FEF8E8;
  color: #F5BC41;
  border: solid 1px #F5BC41;
  flex-shrink: 0;
}

.inHand {
  background: #EAF4FE;
  color: #549BF8;
  border: solid 1px #549BF8;
  flex-shrink: 0;
}

.end {
  background: #EBF9F1;
  color: #5FCA71;
  border: solid 1px #5FCA71;
  flex-shrink: 0;
}

.list-item-info {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #606060;

  img {
    width: 14px;
    height: auto;
    margin-right: 4px;
  }
}

.list-item-date {
  display: flex;

  .list-item-date-end{
    margin-left: 16px;
  }
  span {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #606060;

    img {
      width: 14px;
      height: auto;
      margin-right: 4px;
      vertical-align: sub;
    }
  }
}

.list-item-action {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.count-down {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #303030;
}

.goExamOutline {
  background-color: #DD594A;
  color: #fff;
  cursor: pointer;
  border: #DD594A solid 1px;
}

.scoreQuery {
  background: rgba(221, 89, 74, 0.08);
  border: 1px solid rgba(221, 89, 74, 0.2);
  color: #DD594A;
  cursor: pointer;
}

.tags .el-tag {
  cursor: pointer;
}

@media (max-width: 1200px) {
  .exam-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .exam-grid {
    grid-template-columns: 1fr;
  }
}
</style>
